'use strict';

let _dashboardSpinnerEl,
    /**
     * The Basic dialog popup.
     * @type {{setElement: Function, show: Function}}
     */
    CustomDialog = {
        /**
         * In order to use custom dialog, this are hosted in the main App module. And then,
         * available through this Object for the rest of the application.
         * @param notificationEl
         */
        setElement(notificationEl) {
            _dashboardSpinnerEl = notificationEl;
        },

        show() {
            if(_dashboardSpinnerEl) {
                _dashboardSpinnerEl.show(arguments);
            }
        },

        hide() {
            if (_dashboardSpinnerEl) {
                _dashboardSpinnerEl.hide(arguments);
            }
        }
    };

module.exports = CustomDialog;



/** WEBPACK FOOTER **
 ** ./src/views/Dashboard/DashboardSpinnerHolder.js
 **/